import React from "react";
import { Link } from "react-router-dom";

import MySchedulePage from "./Schedule";
import ProgramInquiry from "./ProgramInquiry";
import { useAuth } from "../auth/AuthContext";
import { useLanguage } from "../i18n/LanguageContext";
import { useProgramAccess } from "../hooks/useProgramAccess";

/**
 * The single Program destination.
 *
 * Requesting a program and following one are two ends of the same journey, so
 * they share a route: members without access land on the request form, and the
 * same link becomes their program the moment access is granted.
 */
const MyProgram = () => {
  const { t } = useLanguage();
  const { user, loading: authLoading } = useAuth();
  const { hasAccess, loading } = useProgramAccess();

  if (authLoading || loading) {
    return (
      <div className="page-content hpa-program-page">
        <div className="hpa-program-shell">
          <div className="container">
            <div className="hpa-program-loading">
              <div className="spinner-border text-danger" role="status" />
              <p>{t("Loading your program...")}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="page-content hpa-program-page">
        <div className="hpa-program-shell">
          <div className="container">
            <div className="hpa-program-auth">
              <span className="hpa-program-empty__icon"><i className="fa-solid fa-lock" /></span>
              <h2>{t("Login Required")}</h2>
              <p>{t("Log in to request your personalized program or open the one your coach built.")}</p>
              <Link to="/auth?redirect=program-inquiry" className="hpa-program-primary-btn">
                {t("Login")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return hasAccess ? <MySchedulePage /> : <ProgramInquiry />;
};

export default MyProgram;
